import { MicrophoneIcon } from "@heroicons/react/24/solid";

interface MicToggleButtonProps {
  isLive: boolean;
  onToggle: () => void;
}

export function MicToggleButton({ isLive, onToggle }: MicToggleButtonProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={isLive}
      aria-label={isLive ? "Mute microphone" : "Unmute microphone"}
      aria-keyshortcuts="Space"
      title={isLive ? "Click or press Space to mute" : "Click or press Space to talk"}
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
      className={[
        "relative h-12 w-12 rounded-full flex items-center justify-center",
        "transition-colors duration-150",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-sky-500",
        "shadow-md",
        isLive ? "bg-sky-500" : "bg-text-muted",
      ].join(" ")}
    >
      {isLive ? (
        <MicrophoneIcon className="h-6 w-6 text-white" aria-hidden="true" />
      ) : (
        <svg
          viewBox="0 0 24 24"
          className="h-6 w-6 text-white"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M12 14a3 3 0 0 0 3-3V5a3 3 0 1 0-6 0v6a3 3 0 0 0 3 3Zm5-3a5 5 0 0 1-10 0H5a7 7 0 0 0 6 6.92V21h2v-3.08A7 7 0 0 0 19 11h-2Z" />
          <line
            x1="4"
            y1="4"
            x2="20"
            y2="20"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
          />
        </svg>
      )}
    </button>
  );
}
